import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import './AdditionCard.css';
import UploadDownloadArrow from '../Svg/UploadDownloadArrow';
import { SalesContext } from '../../../Context/SalesContext';
import GreenBgTick from "../Svg/GreenBgTick";
import { tagOnAdditionalService, tagOnRemoveAdditionalService } from "./../../../Tagging/SalesTagging";

const AdditionalCard = (props) => {

  const context = useContext(SalesContext);

  const {
    setAdditionalServices,
    setAdditionalVas,
    setLteReviewData,
    additionalVas,
    setSelectedAdditionalServices,
    setUnselectedContractCover
  } = context;
  let handleOnSelect = () => undefined;
  
  if (props.vasCategory === "superWifi" || props.vasCategory === "contractCover") {
    handleOnSelect = function () {
      let addVas = context.additionalVas;
      let removed = false;

      if (addVas) {
        for (let index = 0; index < addVas.length; index++) {
          if (addVas[index].category === props.vasCategory){
            if (props.offerId === addVas[index].offerId)
              removed = true;

            addVas.splice(index, 1);

            if (props.vasCategory == "contractCover")
              setUnselectedContractCover(true);

            setSelectedAdditionalServices({ key: props.vasCategory, value: false });
            tagOnRemoveAdditionalService(
              props.acronym,
              1,
              props.priceDescription
            );
          }
        }
      }

      if (removed == false) {
        if (props.vasCategory == "contractCover")
          setUnselectedContractCover(false);

        if (!addVas)
          addVas = [];

        addVas.push({
          "category" : props.vasCategory,
          "offerId" : props.offerId,
          "price" : props.price,
          "contractTerm" : props.contractTerm,
          "acronym" : props.acronym,
          "displayName" : props.displayName,
          "priceDescription": props.priceDescription,
          "discount": props.discount ? props.discount : "",
          "imgUrl": props.imgUrl
        });

        setSelectedAdditionalServices({ key: props.vasCategory, value: true });
        tagOnAdditionalService(
          props.acronym,
          1,
          props.priceDescription
        );
      }

      setAdditionalVas(addVas)
    }

    if (props.vasCategory === "superWifi")
      return (
        <div className="ie-compatibility">
          <button
            onClick={() => handleOnSelect()}
            className={`cardWrapper ${props.isSelected ? 'green-border' : ''} `}
            automationid={`SalesLead_Button_HandleOnSelectButton_${props.index}`}
          >
            <div className='up_down_icon' automationid={`SalesLead_Div_UpDownIcon_${props.index}`}><img className="super-wifi-img" src={props.imgUrl} /></div>

            <div className='card-details' automationid={`SalesLead_Div_CardDetails_${props.index}`}>
              <p className='size' automationid={`SalesLead_Paragraph_CardSize_${props.index}`}>{parseInt(props.contractTerm) ? "Pay monthly" : "Pay once-off"}</p>
              <p className="quantity">1</p>
              {/* <p className='device-name' automationid={`SalesLead_Paragraph_CardDeviceName_${props.index}`}>Nokia Beacon 1</p> */}
            </div>
            <div className="divider-line"></div>
            <div className='card-details' automationid={`SalesLead_Div_CardDetails_${props.index}`}>
              <p className='price' automationid={`SalesLead_Paragraph_CardPrice_${props.index}`}>{props?.price} {parseInt(props.contractTerm) ? "x " + props.contractTerm : "Once-off"}</p>
              <p className='price-discount' automationid={`SalesLead_Paragraph_CardPrice_${props.index}`}>{props?.discount}</p>
            </div>
            {
              props.isSelected ? 
                <div className="green-bg-tick" automationid={`SalesLead_Div_GreenBgTick_${props.index}`}><GreenBgTick /></div>
                :
                null
            }
          </button>
        </div>
      );

    else if (props.vasCategory === "contractCover") 
      return (
        <div className="ie-compatibility">
          <button
            onClick={() => handleOnSelect()}
            className={`cardWrapper ${props.isSelected ? 'green-border' : ''} `}
            automationid={`SalesLead_Button_HandleOnSelectButton_${props.index}`}
          >
            <div className='up_down_icon' automationid={`SalesLead_Div_UpDownIcon_${props.index}`}><img className="super-wifi-img" src={props.imgUrl} /></div>

            <div className='card-details' automationid={`SalesLead_Div_CardDetails_${props.index}`}>
              <p className='contract-cover-card-header' automationid={`SalesLead_Paragraph_CardSize_${props.index}`}>vodasure | contract cover</p>
              <p className='contract-cover-card-text' automationid={`SalesLead_Paragraph_CardSize_${props.index}`}>{props.additionalText}</p>
            </div>
            <div className='card-details' automationid={`SalesLead_Div_CardDetails_${props.index}`}>
              <p className='price' automationid={`SalesLead_Paragraph_CardPrice_${props.index}`}>{props?.price} PM</p>
            </div>
            {
              props.isSelected == true ? 
                <div className="green-bg-tick" automationid={`SalesLead_Div_GreenBgTick_${props.index}`}><GreenBgTick /></div>
                :
                null
            }
          </button>
        </div>
      );
  } else if (props.serviceKey === "lte") {

    handleOnSelect = function () {

      if (props.category) {
        if (additionalVas?.parameterId == props?.parameterId){
          setLteReviewData(null);
          setAdditionalServices(null);
        }else{
          setAdditionalServices({
            key: props.category,
            offerId: props.offerId,
            actionId: props.actionId,
            parameterId: props.parameterId
          });
  
          setLteReviewData({
            displayName: props.displayName,
            promotion: props.promotion,
            size: props.size,
            price: props.price,
            lteImageUrl: props.lteImageUrl
          });
  
          tagOnAdditionalService(
            props.parameterValue,
            1,
            props.priceValue
          );
        }
      }
    }

    return (
      <div>
        <button
          onClick={() => handleOnSelect()}
          className={`cardWrapper ${additionalVas?.parameterId == props?.parameterId ? 'green-border' : ''} `}
          automationid={`SalesLead_Button_HandleOnSelectButton_${props.index}`}
        >

          <div className='up_down_icon' automationid={`SalesLead_Div_UpDownIcon_${props.index}`}><UploadDownloadArrow /></div>

          <div className='card-details' automationid={`SalesLead_Div_CardDetails_${props.index}`}>
            <p className='size' automationid={`SalesLead_Paragraph_CardSize_${props.index}`}>{props?.size}</p>
            <p className='price' automationid={`SalesLead_Paragraph_CardPrice_${props.index}`}>{props?.price} PM</p>
          </div>
          {
            additionalVas?.parameterId == props?.parameterId ? 
              <div className="green-bg-tick" automationid={`SalesLead_Div_GreenBgTick_${props.index}`}><GreenBgTick /></div>
              :
              null
          }
        </button>
      </div>
    );
  }
}

AdditionalCard.propTypes = {
  size: PropTypes.string,
  price: PropTypes.string,
  handleOnClick: PropTypes.number,
  category: PropTypes.string,
  offerId: PropTypes.string,
  actionId: PropTypes.string,
  parameterId: PropTypes.string,
  displayName: PropTypes.string,
  promotion: PropTypes.string,
  lteImageUrl: PropTypes.string,
  priceValue: PropTypes.number,
  parameterValue: PropTypes.string
}

export default AdditionalCard;